export default class ExecutiveAvailabilityFilterViewModel {
    public filterTeam: string = '';
}